let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5bANX")).then(() => parcelRequire('dF97w'));